import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.7 17.89 16 14.273c1.2-1.466 2-3.421 2-5.474C18 3.911 14 0 9 0S0 3.91 0 8.799s4 8.798 9 8.798c2.1 0 4.1-.684 5.6-1.955l3.7 3.617c.2.195.5.293.7.293s.5-.098.7-.293a.93.93 0 0 0 0-1.369M2 8.799c0-3.813 3.1-6.844 7-6.844s7 3.031 7 6.843c0 1.858-.8 3.618-2 4.79-1.3 1.272-3 1.956-4.9 1.956-4 .098-7.1-2.933-7.1-6.745m10-.978h-2V5.866c0-.587-.4-.978-1-.978s-1 .391-1 .978v1.955H6c-.6 0-1 .391-1 .978 0 .586.4.977 1 .977h2v1.955c0 .587.4.978 1 .978s1-.391 1-.978V9.776h2c.6 0 1-.39 1-.977s-.4-.978-1-.978"
    }, null, -1)
  ]))]))
}
export default { render: render }